import OIDonate from './main'

window.OIDonate = OIDonate
